import * as yup from 'yup'

const LoginValidator = yup.object().shape({
  email: yup.string().email().trim().required(),
  password: yup.string().trim().required(),
})

export default LoginValidator
